import React from 'react';
import PropTypes from 'prop-types';

import '../../../styles/TicketStatusTiles.css';
import '../../../styles/railSeoSprite.css';
import { ticketStatusTilesData } from '../constants/PnrSeoConstants';

const TicketStatusTiles = ({ customClass = '' }) => {
  return (
    <div className={`ticketStatusTiles ${customClass}`}>
      {ticketStatusTilesData.map((item, idx) => (
        <a key={item.key} href={item.url}>
          <span className={`${item.iconName} sprite`}></span>
          {item.text}
          <span className="blueChevron arrow"></span>
        </a>
      ))}
    </div>
  );
};

TicketStatusTiles.propTypes = {
  customClass: PropTypes.string
};

export default TicketStatusTiles;
